<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title" style="font-size: 17px;">
      {{ "Multiple Measurements" | translate | async }}<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">
    <table>
      <thead>
        <tr>
          <th><button mat-raised-button color="warn" [disabled]="true"><span class="material-icons button__icon"></span><span class="button__text" style="color: white;">M #</span></button></th>
          <th><button mat-raised-button color="warn" [disabled]="true"><span class="material-icons button__icon"></span><span class="button__text" style="color: white;">Value</span></button></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of MeasurementList">
          <tr *ngIf="ComponentTypeId === 231">
            <td  *ngIf="data.RowId === 1">Forward</td>
            <td  *ngIf="data.RowId === 2">Reverse</td>
            <td  *ngIf="data.RowId != 1 && data.RowId !=2">{{ data.RowId }}</td>
            <td style="text-align-last: center;"><input style="width: 100px;" type="number" [(ngModel)]="data.value" (change)="updateMeasurement(data, $event)"></td>
            <!-- <td>{{ data.value }}</td> -->
          </tr>
          <tr *ngIf="ComponentTypeId != 231">
            <td>{{ data.RowId }}</td>
            <td style="text-align-last: center;"><input style="width: 100px;" type="number" [(ngModel)]="data.value" (change)="updateMeasurement(data, $event)"></td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
